import { Service } from '@tino-frontend/adapters'
import { TutorialListResponse } from '@types'

export class TutorialService {
  constructor(private readonly http: Service) {
    this.http = http
  }

  listAll(): Promise<TutorialListResponse> {
    return this.http.get<unknown, TutorialListResponse>(`/v1/tutorial`)
  }

  async view(tutorialId: string): Promise<TutorialListResponse> {
    return this.http.post(`/v1/tutorial/${tutorialId}`)
  }
}
